import "../styles/_app.scss";
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import MatxTheme from "./MatxLayout/MatxTheme/MatxTheme";
import AppContext from "./appContext";
import history from "history.js";
import Loading from "../matx/components/MatxLoadable/Loading";

import routes from "./RootRoutes";
import { Store, Persistor } from "./redux/Store";
import Auth from "./auth/Auth";
import MatxLayout from "./MatxLayout/MatxLayout";
import AuthGuard from "./auth/AuthGuard";
import KeycloakSessionSync from "./auth/KeycloakSessionSync";
import ReactNotification from "react-notifications-component";
import { KeycloakProvider, useKeycloak } from "./auth/KeycloakContext";

const AppContent = () => {
  const { userAuthenticated } = useKeycloak();

  return (
    <>
      {userAuthenticated ? (
        <AppContext.Provider value={{ routes }}>
          <ReactNotification></ReactNotification>
          <Provider store={Store}>
            <PersistGate loading={<Loading />} persistor={Persistor}>
              <Auth>
                <MatxTheme>
                  <Router history={history}>
                    <>
                      <KeycloakSessionSync />
                      <AuthGuard>
                        <MatxLayout />
                      </AuthGuard>
                    </>
                  </Router>
                </MatxTheme>
              </Auth>
            </PersistGate>
          </Provider>
        </AppContext.Provider>
      ) : (
        <Loading />
      )}
    </>
  );
};

const App = () => {
  return (
    <KeycloakProvider>
      <AppContent />
    </KeycloakProvider>
  );
};

export default App;
